<template>
  <RecruitmentSkeleton v-if="isLoading && !demands.length" />
  <section class="demand-list">
    <transition-group tag="div" name="dashboard-list">
      <component
        :is="cardToDisplay(demand.getType())"
        v-for="demand in demands"
        :id="demand.isPermanent() ? demand.getDemandId() : demand.getMissionId()"
        :key="demand.getDemandId()"
        :demand="demand"
      />
    </transition-group>
  </section>
</template>

<script>
  import { DEMAND_TYPES } from "@core/constants";

  import InterimDemand from "@etab/components/dashboard/demand/InterimDemand.component.vue";
  import AEDemand from "@etab/components/dashboard/demand/AEDemand.component.vue";
  import CDIDemand from "@etab/components/dashboard/demand/CDIDemand.component.vue";
  import SeasonalDemand from "@etab/components/dashboard/demand/SeasonalDemand.component.vue";
  import RecruitmentSkeleton from "@etab/components/dashboard/demand/RecruitmentSkeleton.component.vue";

  export default {
    components: {
      RecruitmentSkeleton,
    },
    props: {
      isLoading: {
        type: Boolean,
        default: false,
      },
      demands: {
        type: Array,
        default: (name) => [],
      },
    },
    methods: {
      cardToDisplay(contractType) {
        switch (contractType) {
          case DEMAND_TYPES.INTERIM:
            return InterimDemand;
          case DEMAND_TYPES.AE:
            return AEDemand;
          case DEMAND_TYPES.CDI:
            return CDIDemand;
          case DEMAND_TYPES.SEASON:
            return SeasonalDemand;
          default:
            return null;
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .demand-list {
    margin-top: 1rem;
    display: flex;
    flex-direction: column;
  }
</style>
